module.exports = {
  "/doi": {
    "name": "doi",
    "success": {
      "default": [
        "DOI_PAGE_LOADED"
      ]
    }
  },
  "/doi-default-confirmation": {
    "name": "doi-default-confirmation",
    "success": {
      "default": [
        "DOI_DEFAULT_CONFIRMATION_PAGE_LOADED"
      ]
    }
  },
  "/email": {
    "name": "email",
    "success": {
      "subscriptions pre loaded": [
        "SUBSCRIPTIONS_PRE_LOAD"
      ],
      "subscriptions loaded": [
        "SUBSCRIPTIONS_LOADED"
      ],
      "subscriptions redirect": [
        "SUBSCRIPTIONS_REDIRECT"
      ],
      "subscriptions invalid product": [
        "SUBSCRIPTIONS_INVALID_PRODUCT"
      ],
      "empty query params": [
        "SUBSCRIPTIONS_EMPTY_QUERY_PARAMS"
      ],
      "missing or invalid query params": [
        "SUBSCRIPTIONS_INVALID_QUERY_PARAMS"
      ],
      "invalid format": [
        "SUBSCRIPTIONS_USER_ERROR"
      ]
    }
  },
  "/backup": {
    "name": "backup",
    "success": {
      "default": [
        "BACKUP_PAGE_LOADED"
      ]
    }
  },
  "/loadFailure": {
    "name": "loadFailure",
    "success": {
      "default": [
        "ERROR_PAGE_LOADED"
      ]
    }
  }
};